import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { API } from "aws-amplify";
import { generatePdfQuoteAS } from "../Services/GeneratePdfQuoteAS";
import { formatNumber, typeDocument, currency } from "../Utils/utils";
import Loading from "../Components/loading";
import TitleHeader from "./titleHeader";
import img from "../Resources/img/image-user-2.jpg";
import useBeforeFirstRender from '../customHook/useBeforFirstRender';
import {downloadPdf} from '../Store/requestPdf/actions';
import { createClientSAS, updateClientSAS, openModal } from "../Store/simulate/actions";
import { ToastContainer } from "react-toastify";
import ModalGenerateQuote from '../Components/modalGenerateQuote';
import { defaultFormShape } from "../Utils/constants";
import ModalAlert from "../Components/FormElements/modalAlert";
import Step from "../Components/FormElements/step";

export default function DataVerification() {
  const [loadingClick, setLoadingClick] = useState(false);

  const [errorServiceUpdateSAS , setErrorServiceUpdateSAS] = useState(false);

  const data = useSelector(state => state.simulate.policy.client);
  const beneficiary = useSelector(state => state.simulate.policy.beneficiary);
  const workData = useSelector(state => state.simulate.policy.workData);
  const healthStatementData = useSelector(state => state.simulate.policy.healthStatement);
  const answersData = useSelector(state => state.simulate.policy.answers);
  const openAlert = useSelector(state => state.simulate.policy.openModal);
  const dataModalAlert = useSelector(state => state.simulate.policy.dataModal);
  const generateQuote = useSelector(state => state.simulate.policy.generateQuote);
  const loadingAlert = useSelector(state => state.simulate.policy.loading);
  const simulation =  data.datosSimulacion;
  const client  = data.datosCliente;
  const clientData  = client ? client.datosParticulares : null;
  const history = useHistory();
  const dispatch = useDispatch();
  const loading_downloadpdf = useSelector(
    state => state.requestPdf.loading
  );

  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [dataModelQuote,setDataModelQuote] = useState(null);
  const [dataModal, setDataModal] = useState({
    status: false,
    message: "",
    numberQuote: "",
  });

  const navigationPrev = () => {
    history.push('/simulaciones/info-complementaria-2');
  };

  const navigationNext = () => {
    history.push("/simulaciones");
  };

  useBeforeFirstRender(client);

  const uploadRequest = (dataM) =>  {
    downloadPdf(dispatch,dataM.idCotizacion, setLoadingClick)
  }

  const handleSubmit = async () => {
    setLoadingClick(true);

    if (client.idetercero && client.idetercero !== "" && client.idetercero !== null) {
      const reqUpdate = {
        body: {
          id: client.idetercero.toString(),
          phone: clientData.phone,
          email: clientData.email,
          address: {
            type: clientData.address.type,
            name: clientData.address.name,
            number: clientData.address.number,
            district: clientData.address.district
          }
        }
      };
      updateClientSAS(reqUpdate, dispatch);
      setLoadingClick(false);
    }
    else {
      const reqCreate = {
        body: clientData
      };
      createClientSAS(reqCreate, dispatch);
      setLoadingClick(false);
    }
  };

  useEffect(() => {
    async function processQuote() {
      const healthStatement = {};
      healthStatementData.map(item => {
        healthStatement[item.sk] = item.value;
      });

      const request = {
        body: {
          idSimulacion: data.idSimulacion,
          datosCliente: {
            datosParticulares: clientData,
            beneficiarios: {
              legales: beneficiary.length > 0 ? false : true,
              personalizados: beneficiary
            },
            datosLaborales: workData,
            answers: {
              ...healthStatement,
              ...answersData
            },
          },
          estado: "pendiente",
          errorServiceUpdateSAS
        }
      };

      const response = await API.post("api-rentas", "/save-quote", request);
      setIsLoading(false);
      setOpen(true);
      if (response.status) {
        setDataModal({
          ...dataModal,
          status: true,
          message: "Se generó la cotización correctamente",
          // numberQuote: response.data.numCotizacion
        });

        let dataQuote = response.data;
        const datosCotizacion = {
          moneda: currency[dataQuote.simulation.request.producto.moneda],
          periodo: dataQuote.simulation.request.datosParticulares.find(item => item.nombre === 'anios').valor,
          prima: dataQuote.simulation.request.datosParticulares.find(item => item.nombre === 'prima').valor,
          tasa: dataQuote.simulation.response_value.tasa.toFixed(2),
        };
        dataQuote.numCotizacion = '';
        dataQuote.numSimulacion = dataQuote.simulation.simulacionId;
        dataQuote.fechaCreacionUnix = dataQuote.fechaCreacion;
        dataQuote.datosCotizacion = datosCotizacion;
        dataQuote.rescate = dataQuote.simulation.response_value.rescue;
        dataQuote.cobertura = dataQuote.simulation.response_value.toppings;
        dataQuote.datosCliente.documento = dataQuote.documentoCliente;
        dataQuote.datosCliente.nacimiento = dataQuote.simulation.request.datosParticulares.find(item => item.nombre === 'fnacimiento').valor;
        dataQuote.datosCliente.nombres = dataQuote.nombreCliente;
        dataQuote.datosCliente.tipoDoc = typeDocument[dataQuote.tipoDocCliente];
        dataQuote.datosCliente.datosParticulares = clientData;
        dataQuote.asesor = dataQuote.nombreAsesor;

        generatePdfQuoteAS(dataQuote);
        setDataModelQuote(response.data);

      }
      else {
        setDataModal({
          ...dataModal,
          status: false,
          message: "Ocurrió un error al generar la cotización",
          numberQuote: ""
        });
      }
    }
    if (generateQuote) {
      processQuote();
    }
  }, [generateQuote]);

  return (
    <div className="container">
      <div className="dataVerification">
        <div className="column">
          <Step handleClick={() => navigationPrev()} step="7" total="7"/>
          <TitleHeader 
            title="Verificación de"
            titleBold="datos"
            subtitle="Revisemos que los datos ingresados sean los correctos"
          />
          <div className="cardVerification">
            <div className="cardVerification__head">
              <div className="cardVerification__head__title">
                Datos de la cotización
              </div>
            </div>
            <div className="cardVerification__body">
              <div className="cardVerification__body__title">
                Vida Ahorro Seguro
              </div>
              <div className="cardVerification__body__table">
                <div className="row">
                  <div className="row__title">Prima Total</div>
                  <div className="row__description">
                    {simulation && simulation.moneda.simbolo}{" "}
                    {simulation && formatNumber.new(simulation.prima)}
                  </div>
                </div>
                <div className="row">
                  <div className="row__title">Retorno Total</div>
                  <div className="row__description">
                    {simulation && simulation.moneda.simbolo}{" "}
                    {simulation && formatNumber.new(simulation.primaTotal)}
                  </div>
                </div>
                <div className="row">
                  <div className="row__title">Periodo</div>
                  <div className="row__description">
                    {simulation && (Number(simulation.periodo) === defaultFormShape.period6months ? 6 : simulation.periodo)}{" "}
                    {simulation && (Number(simulation.periodo) === defaultFormShape.period6months ? 'meses' : (Number(simulation.periodo) > 1 ? "años" : "año"))}
                  </div>
                </div>
                <div className="row">
                  <div className="row__title">Tasa</div>
                  <div className="row__description">
                    {simulation && (simulation.tasa + '%')}
                  </div>
                </div>
                <div className="row">
                  <div className="row__title">Coberturas adicionales</div>
                  <div className="row__description">
                    {simulation && (!simulation.onlyPlaneCreate && !simulation.cobAdicionales? 'SI' : 'NO')}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="cardVerification">
            <div className="cardVerification__head">
              <div className="cardVerification__head__title">
                Datos del asegurado
              </div>
            </div>
            <div className="cardVerification__body">
              <div className="cardVerification__body__title">
                {clientData && (`${clientData.names} ${clientData.firstName} ${clientData.lastName}`).toLowerCase()}
              </div>
              <div className="cardVerification__body__table">
                <div className="row">
                  <div className="row__title">
                    {client && client.tipoDoc.nombre}
                  </div>
                  <div className="row__description">
                    {client && client.documento}
                  </div>
                </div>
                {clientData && clientData.birthdate && 
                  <div className="row">
                    <div className="row__title">F. de nacimiento</div>
                    <div className="row__description">{clientData.birthdate}</div>
                  </div>
                }
                {clientData && clientData.sexo && 
                  <div className="row">
                    <div className="row__title">Sexo</div>
                    <div className="row__description">{clientData.sexo}</div>
                  </div>
                }
                {clientData && clientData.mobile && 
                  <div className="row">
                    <div className="row__title">Celular</div>
                    <div className="row__description">{clientData.mobile}</div>
                  </div>
                }
                {clientData && clientData.email && 
                  <div className="row">
                    <div className="row__title">Correo electrónico</div>
                    <div className="row__description">{clientData.email}</div>
                  </div>
                }
                {clientData && clientData.address && clientData.address.type &&
                  <div className="row">
                    <div className="row__title">Dirección</div>
                    <div className="row__description">{`${clientData.address.type}. ${clientData.address.name.toUpperCase()} ${clientData.address.number}`}</div>
                  </div>
                }
              </div>
            </div>
          </div>
          <div className="cardVerification">
            <div className="cardVerification__head">
              <div className="cardVerification__head__title">
                Datos de los beneficiarios
              </div>
            </div>
            <div className="cardVerification__body">
              {beneficiary.length > 0 ? (
                <>
                  {beneficiary.map((item, index) => (
                    <div key={index}>
                      <div className="cardVerification__body__title">
                        Beneficiario #{index + 1}
                      </div>
                      <div className="cardVerification__body__table">
                        <div className="row">
                          <div className="row__title">
                            {item.tipoDoc == 2 ? "DNI" : "CE"}
                          </div>
                          <div className="row__description">
                            {item.documento}
                          </div>
                        </div>
                        <div className="row">
                          <div className="row__title">Nombres y apellidos</div>
                          <div className="row__description capitalize">
                            {item.nombres} {item.apePaterno} {item.apeMaterno}
                          </div>
                        </div>
                        <div className="row">
                          <div className="row__title">Relación</div>
                          <div className="row__description">
                            {item.relacion}
                          </div>
                        </div>
                        <div className="row">
                          <div className="row__title">Porcentaje</div>
                          <div className="row__description">
                            {item.porcentaje}%
                          </div>
                        </div>
                      </div>
                      <br />
                    </div>
                  ))}
                </>
              ) : (
                <div>Herederos Legales</div>
              )}
            </div>
          </div>
          <button
            type="button"
            className="buttonCustom md"
            onClick={() => handleSubmit()}
            >
            Generar
          </button>
        </div>
        <div className="column-image">
          <img src={img} />
        </div>
      </div>
      <ModalGenerateQuote
        open = {open}
        dataModal = {dataModal}
        navigationNext = {navigationNext}
        setOpen = {setOpen}
        dataModelQuote = {dataModelQuote}
        uploadRequest = {uploadRequest}
        loadingClick={loadingClick}
      />
      <ToastContainer containerId={"A"} />
      <ModalAlert 
        data={dataModalAlert} 
        open={openAlert} 
        handleClick={() => dispatch(openModal(false))}
        navigationNext={navigationNext}
        setErrorServiceUpdateSAS={setErrorServiceUpdateSAS}
      />
      {(isLoading ||loading_downloadpdf || loadingAlert) && <Loading  />}
    </div>
  );
}
